/* eslint-disable react/destructuring-assignment */
import { useContext, useMemo } from 'react';
import { getSwapConfigFromProps } from '../helpers';
import type { MoonPaySwapProps } from '../types';
import { MoonPayContext } from './MoonPayProvider';
import { MoonPayWidget } from './MoonPayWidget';

export function MoonPaySwapWidget(props: MoonPaySwapProps) {
  const { apiKey, environment } = useContext(MoonPayContext);

  const config = useMemo(
    () =>
      getSwapConfigFromProps({
        props,
        apiKey,
        environment,
        debug: false,
        signature: props.signature || '',
      }),
    [props, apiKey, environment],
  );

  return (
    <MoonPayWidget
      config={config}
      visible={props.visible}
      onUrlSignatureRequested={props.onUrlSignatureRequested}
      className={props.className}
      style={props.style}
    />
  );
}
